var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"srcdoc":_vm.preview,"width":"100%","height":"100%"},on:{"load":_vm.resizeIframe}})}
var staticRenderFns = []

export { render, staticRenderFns }